import { render, staticRenderFns } from "./GestionModules.vue?vue&type=template&id=08260512&"
import script from "./GestionModules.vue?vue&type=script&lang=js&"
export * from "./GestionModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports